export class InvalidDataError extends Error {
  constructor(m: string) {
    super(m);
    this.name = "InvalidDataError";
  }
}
